const TOKEN_KEY = 'token';
let capturedToken: string | null | undefined;

/**
 * Captures the one-time link secret from the URL fragment and removes it from
 * browser history before React renders any review content. The token remains
 * in memory only until the visitor explicitly starts the review.
 */
export function captureReviewTokenFromFragment(
    location: Pick<Location, 'hash' | 'pathname' | 'search'> = window.location,
    history: Pick<History, 'replaceState'> = window.history,
): string | null {
    const fragment = location.hash.startsWith('#') ? location.hash.slice(1) : location.hash;
    if (!fragment) return null;

    const params = new URLSearchParams(fragment);
    const token = params.get(TOKEN_KEY)?.trim() ?? '';
    history.replaceState(null, '', `${location.pathname}${location.search}`);
    return token.length >= 32 && token.length <= 512 ? token : null;
}

/** Called before telemetry starts so the fragment cannot enter an error event. */
export function primeReviewTokenFromCurrentUrl(
    location: Pick<Location, 'hash' | 'pathname' | 'search'> = window.location,
    history: Pick<History, 'replaceState'> = window.history,
): void {
    if (location.pathname !== '/onboarding-review') return;
    capturedToken = captureReviewTokenFromFragment(location, history);
}

/** One read only; the link secret is discarded from module memory immediately. */
export function consumeCapturedReviewToken(): string | null {
    if (capturedToken === undefined) primeReviewTokenFromCurrentUrl();
    const token = capturedToken ?? null;
    capturedToken = null;
    return token;
}
